import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconRotate = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconRotate.dimensions.width} ${IconRotate.dimensions.height}`}
      {...otherProps}
    >
      <G fill="none" fillRule="evenodd">
        <Path
          fillRule="nonzero"
          fill={color || Color.premiumBlack}
          stroke={color || Color.premiumBlack}
          d="M.502 11.704c.178-.38.438-.405.699-.074.665.835 1.33 1.67 2.041 2.5V6.496c0-1.572 1.035-2.861 2.562-3.194.268-.055.55-.074.823-.074h7.502c0-.011.007-.024.014-.036-.363-.289-.726-.583-1.09-.872-.486-.387-.972-.78-1.459-1.167-.116-.093-.198-.196-.184-.35.026-.282.335-.398.567-.215.405.32.81.645 1.206.964.706.565 1.412 1.13 2.118 1.701.268.215.268.424 0 .633-1.096.878-2.186 1.756-3.282 2.628-.198.16-.404.154-.534-.012-.131-.166-.082-.363.116-.528.788-.626 1.569-1.259 2.357-1.886.062-.049.117-.098.205-.171-.095 0-.157-.013-.212-.013H6.567c-1.336 0-2.35.811-2.597 2.076-.033.176-.05.355-.049.534v7.437c0 .055 0 .116.007.22l.308-.38c.59-.737 1.172-1.474 1.762-2.204.164-.21.397-.24.555-.074.13.141.123.313-.02.503l-1.604 2.009c-.343.423-.678.853-1.02 1.277-.213.263-.425.263-.638 0-.857-1.075-1.713-2.143-2.57-3.218-.075-.098-.137-.208-.198-.313v-.074.074l-.001-.067Z"
        />
      </G>
    </Svg>
  )
}

IconRotate.dimensions = {
  width: 16,
  height: 16,
}

export default IconRotate
